
export class MediaContainerEvent {
}

/**
 * Indicates that an attempt to play a video by a MediaContainer was rejected by the browser, even
 * after the video was muted and an attempt was made to play it muted.
 */
MediaContainerEvent.VIDEO_PLAY_REJECTED = 'VIDEO_PLAY_REJECTED';

/**
 * Indicates that an attempt to play a video by a MediaContainer was rejected by the browser, most
 * likely because the video was not muted and the user had not first interacted with the page.
 * See: https://developer.chrome.com/blog/autoplay/
 */
MediaContainerEvent.UNMUTED_VIDEO_PLAY_REJECTED = 'UNMUTED_VIDEO_PLAY_REJECTED';
